import { render, staticRenderFns } from "./VvBackButton.vue?vue&type=template&id=0315d5d6&scoped=true&"
import script from "./VvBackButton.vue?vue&type=script&lang=js&"
export * from "./VvBackButton.vue?vue&type=script&lang=js&"
import style0 from "./VvBackButton.vue?vue&type=style&index=0&id=0315d5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315d5d6",
  null
  
)

export default component.exports